import React, { useState } from "react";
import PropTypes from "prop-types";
import "./notification.scss";

/**
 * Primary UI component for user interaction
 */
export const Notification = ({
  info,
  warning,
  title,
  description,
  ...props
}) => {
  return (
    <div
      className={`c-notification ${info ? "c-notification--info" : ""} ${
        warning ? "c-notification--warning" : ""
      }`}
    >
      <div className="c-notification__header">
        {info && <i class="fa-solid fa-circle-info"></i>}
        {warning && <i class="fa-solid fa-circle-exclamation"></i>}

        <p>{title}</p>
      </div>
      <p>{description}</p>
    </div>
  );
};

Notification.propTypes = {
  /**
   * info
   */
  info: PropTypes.bool,
  /**
   * warning
   */
  warning: PropTypes.bool,
  /**
   * title
   */
  title: PropTypes.string,
  /**
   * description
   */
  description: PropTypes.string,
};

Notification.defaultProps = {
  info: true,
  warning: false,
  title: "Title",
  description: "Description",
};
